/* Copyright (c) 2020 Paul Nebel */

import * as Tone from 'tone';

// private variables
let transport, maxLoopDuration;
const startDelay = '+0.5';

class PlayerMachine {
    constructor() {
        if (!PlayerMachine.instance) {          
            transport = Tone.Transport;
            maxLoopDuration = { value: '1m' };
        }
        return PlayerMachine.instance;
    }

    addOneOffCallback(callback, startTime = '0m') {
        return transport.scheduleOnce(callback, startTime);
    }

    addCallback(loopCallback, loopDuration, loopStart = '0m') {
        const context = {
            id: null,
            loopDuration: null,
        };
        if (loopCallback && loopDuration) {
            context.id = transport.scheduleRepeat(
                loopCallback,
                loopDuration,
                loopStart,
            );
            this.loopDuration = loopDuration;
            context.loopDuration = maxLoopDuration;
        }
        return context;
    }

    removeCallback(loopId) {
        transport.clear(loopId);
    }

    get loopDuration() {
        return maxLoopDuration;
    }

    set loopDuration(loopDuration) {
        if (!transport.loop || !maxLoopDuration || (Tone.Time(maxLoopDuration.value) < Tone.Time(loopDuration))) {
            transport.setLoopPoints(0, loopDuration);
            transport.loop = true;
            maxLoopDuration.value = loopDuration;
        }
    }
    
    get bpm() {
        return transport.bpm;
    }

    set bpm(value) {
        if (transport.bpm !== value) {
            transport.bpm.value = value;
        }
    }

    get state() {
        return transport.state;
    }

    start() {
        transport.start(startDelay, '0:0:0');
    }

    pause() {
        transport.pause();
    }

    stop() {
        transport.stop();
    }

    get audioContext() {
        return Tone.getContext();
    }

    get progress() {
        return transport.progress;
    }
}

const instance = new PlayerMachine();
Object.freeze(instance);

export default instance;